import DownloadSection from 'components/SongActionButtons/components/DownloadSection';
import {
  ReleaseButtonContainer,
  ReleaseIconButton,
} from 'components/SongActionButtons/components/ReleaseButton';
import { AnalyticsEventLocation } from 'services/analytics/entities';
import { useAddToLibrary } from 'services/hooks';
import { Song } from 'services/store/songs/types';
import { Container } from './styled';
import DeleteButton from './components/DeleteButton';

type PropsType = {
  song: Song;
};

const ActionButtons = ({ song }: PropsType) => {
  const { id, songType } = song;
  const location = AnalyticsEventLocation.LIBRARY;

  const { addSongToLibrary } = useAddToLibrary({
    songId: id,
    location,
  });

  return (
    <Container>
      <ReleaseButtonContainer songId={id} location={location}>
        <ReleaseIconButton songId={id} />
      </ReleaseButtonContainer>
      <DownloadSection
        songId={id}
        songType={songType}
        location={location}
        addToLibrary={addSongToLibrary}
      />
      <DeleteButton songId={id} />
    </Container>
  );
};

export default ActionButtons;
